import { css } from "styled-components/macro";

export default css`
  .marketing-container {
    background: #ffffff;
    padding: 32px 32px;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    max-width: 500px;
    margin: 0 auto;
    border-radius: 16px;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  }

  .header-section {
    text-align: center;
    margin-bottom: 48px;
  }

  .logo-container {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
    margin-bottom: 24px;
  }

  .partner-logo {
    height: 24px;
  }

  .x-symbol {
    color: #202024;
  }

  .lendica-logo {
    height: 24px;
  }

  .main-headline {
    color: #1e293b;
    font-size: 18px;
    font-weight: 500;
    line-height: 1.3;
    margin: 0;
  }

  .features-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 24px;
    margin-bottom: 48px;
    padding: 0 24px;
  }

  .feature-item {
    text-align: center;
  }

  .feature-icon {
    color: white;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 8px;
  }

  .feature-title {
    color: #3c41e7;
    font-size: 20px;
    font-weight: 700;
    margin: 0 0 8px;
  }

  .feature-description {
    color: #29292e;
    font-size: 14px;
    line-height: 1.5;
    margin: 0;
  }

  .cta-section {
    text-align: center;
  }

  .cta-button {
    background: #202024;
    color: white;
    border: none;
    padding: 16px 32px;
    border-radius: 8px;
    font-size: 18px;
    font-weight: 500;
    cursor: pointer;
    width: 100%;
    transition: background-color 0.2s;
  }

  .cta-button:hover {
    background: #202024f0;
  }
`;
